import { useConductorComponent } from "@faire/deprecated-retailer-visitor-shared/features/Conductor/useConductorComponent";
import { Message } from "@faire/messenger/MessageChannel/MessageChannel";
import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import { IWebSocketMessage } from "@faire/web-api--source/indigofair/websockets/IWebSocketMessage";
import { useCallback } from "react";

export const useConductorInvalidationFunctions = () => {
  const { invalidateConductorComponentQuery: invalidateSiteWideTopBanner } =
    useConductorComponent({
      surface: ConductorSurface.SITE_WIDE_TOP_BANNER,
    });
  const { invalidateConductorComponentQuery: invalidateReviewsFeedBanner } =
    useConductorComponent({
      surface: ConductorSurface.REVIEWS_FEED_PAGE_TOP,
    });

  return {
    invalidateSiteWideTopBanner,
    invalidateReviewsFeedBanner,
  };
};

export const useInvalidateProductReviewCampaignComponents = () => {
  const { invalidateSiteWideTopBanner, invalidateReviewsFeedBanner } =
    useConductorInvalidationFunctions();

  const handleInvalidateProductReviewCampaignComponents = useCallback(
    (message: Message) => {
      if (
        message.type === IWebSocketMessage.Type.PRODUCT_REVIEW_INCENTIVE_GRANTED
      ) {
        invalidateSiteWideTopBanner();
        invalidateReviewsFeedBanner();
      }
    },
    [invalidateSiteWideTopBanner, invalidateReviewsFeedBanner]
  );

  return { handleInvalidateProductReviewCampaignComponents };
};
